import { httpCore } from "./http";

const normalize = (data) => (Array.isArray(data) ? data : data?.results || []);

export async function listDepartments(params = {}) {
  const { data } = await httpCore.get("departments/", { params });
  return normalize(data);
}